import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=4515509d&scoped=true"
import script from "./Profil.vue?vue&type=script&lang=js"
export * from "./Profil.vue?vue&type=script&lang=js"
import style0 from "./Profil.vue?vue&type=style&index=0&id=4515509d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515509d",
  null
  
)

export default component.exports